export const asArray = (value) => (Array.isArray(value) ? value : []);

export function normalizeAction(action) {
    if (!action || typeof action !== 'object') return null;
    const properties = asArray(action.properties)
        .filter((p) => p && typeof p === 'object' && typeof p.name === 'string')
        .map((p) => ({
            ...p,
            name: p.name,
            label: p.label || p.name,
            mandatory: !!p.mandatory,
            mandatoryIf: p.mandatoryIf || '',
            type: p.type || p.fieldType || '',
            fieldType: p.fieldType || p.type || '',
        }));

    return {
        ...action,
        objectType: action.objectType || '',
        properties,
    };
}

export function normalizeActions(actions) {
    return asArray(actions)
        .map(normalizeAction)
        .filter((a) => a && a.objectType && a.properties.length > 0);
}

export function previewFromActions(actions) {
    return normalizeActions(actions).reduce((acc, action) => {
        acc[action.objectType] = action.properties;
        return acc;
    }, {});
}

export function normalizePreview(preview) {
    if (!preview || typeof preview !== 'object' || Array.isArray(preview)) return {};
    const normalized = {};
    Object.entries(preview).forEach(([key, value]) => {
        const props = asArray(value)
            .filter((p) => p && typeof p === 'object' && typeof p.name === 'string')
            .map((p) => ({
                ...p,
                name: p.name,
                label: p.label || p.name,
                mandatory: !!p.mandatory,
                mandatoryIf: p.mandatoryIf || '',
                type: p.type || p.fieldType || '',
                fieldType: p.fieldType || p.type || '',
            }));
        if (props.length > 0) normalized[key] = props;
    });
    return normalized;
}

